<template>
  <v-card
    :style="{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100% !important'
    }"
  >
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Dashboard/OverviewCard.vue